// Switch Device Type Templates

import { Template01_Card } from './Template01_Card';

export { Template01_Card } from './Template01_Card';

// Template registry for dynamic selection
export const SwitchTemplates = {
  Template01: () => import('./Template01_Card').then(m => m.Template01_Card),
} as const;

// Default export
export default Template01_Card;
